export default __webpack_public_path__ + "static/media/online-dark-grey.74323c67.png";